import classNames from 'classnames'
import React from 'react'
import './form-boolean.scss'

/**
 * The props
 */
export interface FormBooleanProps {
    /**
     * the value
     */
    value: boolean

    /**
     * Callback for when the value changes
     */
    onChange: (value: boolean) => void
}

/**
 * A boolean in a form.
 * 
 * @author Stan Hurks
 */
export default class FormBoolean extends React.Component<FormBooleanProps> {

    public render = () => {
        return (
            <div className="form-boolean">
                <div className={classNames({
                    'form-boolean-yes': true,
                    'selected': this.props.value
                })} onClick={() => {
                    this.props.onChange(true)
                }}>
                    Yes
                </div>
                <div className={classNames({
                    'form-boolean-no': true,
                    'selected': !this.props.value
                })} onClick={() => {
                    this.props.onChange(false)
                }}>
                    No
                </div>
            </div>
        )
    }
}